import axios from 'axios';
import store from './store.js'
import router from './router.js'

const $axios = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

$axios.interceptors.request.use (
    function (config) {
        const token = store.state.token
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    function (error) {
        return Promise.reject (error);
    }
);

$axios.interceptors.response.use(response => {
    return response
},(error)=>{
    if(error.response.status == 401){
        store.commit('SET_TOKEN', null, { root: true })
        localStorage.removeItem('token')
        router.push({ name: 'auth.login' })
    }
    return Promise.reject(error)
})
  
export default $axios;